module.exports = __webpack_public_path__ + "static/img/8.0962c17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zeus/8.png
// module id = vZuY
// module chunks = 0